module.exports = __webpack_public_path__ + "static/media/integrations.c10a3274.svg";